import React, { Component } from 'react'
import { BrowserRouter, Route } from 'react-router-dom';
import DataTable from '../../../components/DataTable/DataTable';
import FrontendSponsorForm from './FrontendSponsorForm';
import TitleHeader from '../../../components/TitleHeader/TitleHeader'

class FrontendSponsor extends Component {
    render() {
        const columns = [
            { label: 'ชื่อ', align: 'left', name: 'name', search_type: 'string' },
            { label: 'ภาพ', align: 'center', name: 'img', sortable: false },
        ];

        const api_url = '/master/sponsor';

        return (
            <BrowserRouter>
                <div>
                    <TitleHeader program_name='สปอนเซอร์' program_type='Frontend'></TitleHeader>
                    
                    <Route exact path={`${this.props.match.path}/`} component={() => (<DataTable columns={columns} allow_active={true} url={api_url}></DataTable>)} />
                    
                    <Route path={`${this.props.match.path}/create`} component={props => (<FrontendSponsorForm {...props} url={api_url}></FrontendSponsorForm>)} />
                    <Route path={`${this.props.match.path}/:id/edit`} component={props => (<FrontendSponsorForm {...props} url={api_url}></FrontendSponsorForm>)} />
                </div>
            </BrowserRouter>
        )
    }
}

export default FrontendSponsor
